<template>
  <section class='mt-4'>
    <span class="text-sm uppercase text-gray-500">
      Position
    </span>
    <div class="border border-gray-300 p-2 rounded-md">
      <e-position :element="element"></e-position>
      <e-offset class='mt-4' :element="element"></e-offset>
    </div>
  </section>
</template>

<script>
// import Component from "../component_location"
import EPosition from "./EPosition";
import EOffset from "./EOffset";

export default {
  components: { EPosition, EOffset },

  props: {
    element: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {};
  },

  watch: {},

  methods: {},

  computed: {},

  mounted() {},
};
</script>

<style></style>
